import { useIsFeatureEnabled } from '~/composables/useIsFeatureEnabled';
import { useSupabaseUser } from '~/composables/useSupabaseUser';

// Only hides the UI – the API has to restrict reviews to the same users.
export const useIsTaxConfirmationReviewer = () => {
	const user = useSupabaseUser();
	const isFeatureEnabled = useIsFeatureEnabled('taxConfirmation');
	const { public: { taxConfirmationReviewerIds } } = useRuntimeConfig();

	const reviewerIds = String(taxConfirmationReviewerIds)
		.split(',')
		.map((id) => id.trim())
		.filter(Boolean);

	return computed(() => isFeatureEnabled.value && !!user.value?.sub && reviewerIds.includes(user.value.sub));
};
